<template>
    <div>
        <div class="columns">
            <div class="column">
                <h2 class="title is-3">Статистика</h2>
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <h2 class="title is-4">
                    Смс: {{ sum.data.smses }} / Звонки: {{ sum.data.calls }}
                </h2>
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <h2 class="title is-4">
                   Всего потрачено на смс: {{ sum.data.sms_sum }} / на звонки: {{ sum.data.call_sum }}
                </h2>
            </div>
        </div>
        <b-tabs type="is-toggle" expanded v-model="selectedTab">
            <b-tab-item label="Все оповещения">
                <section>
                    <v-btn @click="load('all')" color="primary" style="margin: 10px;"
                        >Загрузить</v-btn
                    >
                    <div class="columns">
                        <div class="column is-6">
                            <b-field>
                                <b-input
                                    placeholder="ID пользователя"
                                    expanded
                                    v-model="all.filters.profile_id"
                                    @change.native="getNotificationStatAll()"
                                >
                                </b-input>
                                <b-datepicker
                                    placeholder="Дата отправки: от"
                                    expanded
                                    @input="getNotificationStatAll()"
                                    v-model="all.filters.date.from"
                                >
                                </b-datepicker>
                                <b-datepicker
                                    placeholder="Дата отправки: до"
                                    expanded
                                    @input="getNotificationStatAll()"
                                    v-model="all.filters.date.to"
                                >
                                </b-datepicker>
                                <b-button @click="clear_filer_all()">Очистить</b-button>
                            </b-field>
                        </div>
                        <div class="column is-2">
                            <h1 class="title is-4">Всего выбрано {{ all.total }}</h1>
                        </div>
                    </div>
                    <b-table
                        :data="all.data"
                        :loading="loading"

                        paginated
                        backend-pagination
                        :total="all.total"
                        :per-page="all.perPage"
                        @page-change="onPageChangeAll"
                        aria-next-label="Next page"
                        aria-previous-label="Previous page"
                        aria-page-label="Page"
                        aria-current-label="Current page"
                        backend-sorting
                        :default-sort="[all.sortField, all.sortOrder]"
                        @sort="onSortAll"
                    >
                        <template slot-scope="props">
                            <b-table-column field="created_at" label="Отправлено в" sortable>
                                {{ props.row.created_at | isoToDateTime }}
                            </b-table-column>

                            <b-table-column field="type" label="Тип" sortable>
                                {{ props.row.type }}
                            </b-table-column>

                            <b-table-column field="profile_id" label="ID пользователя" sortable>
                                {{ props.row.profile_id }}
                            </b-table-column>

                            <b-table-column
                                field="destination"
                                label="Номер / Емейл / Девайс ID"
                                sortable
                            >
                                {{ props.row.destination }}
                            </b-table-column>

                            <b-table-column field="status" label="Статус" sortable>
                                <span :class="type(props.row.status)">
                                    {{ props.row.status }}
                                </span>
                            </b-table-column>

                            <b-table-column field="cost" label="Стоимость" sortable>
                                {{ props.row.cost }}
                            </b-table-column>
                        </template>
                      <template slot="bottom-left">
                        <div class="pagination-controls">
                          <b-select v-model="all.perPage" @change.native="getNotificationStatAll()" class="is-inline-block">
                              <option value="10">10 на странице</option>
                              <option value="20">20 на странице</option>
                              <option value="50">50 на странице</option>
                              <option value="100">100 на странице</option>
                          </b-select>
                        </div>
                      </template>

                    </b-table>
                </section>
            </b-tab-item>

            <b-tab-item label="По пользователям">
                <section>
                    <v-btn @click="load('users')" color="primary" style="margin: 10px;"
                        >Загрузить</v-btn
                    >
                    <div class="columns">
                        <div class="column is-6">
                            <b-field>
                                <b-input
                                    placeholder="ID пользователя"
                                    expanded
                                    v-model="by_user.filters.profile_id"
                                    @change.native="getNotificationStatGroupByUser()"
                                >
                                </b-input>
                                <b-datepicker
                                    placeholder="Дата регистрации: от"
                                    expanded
                                    @input="getNotificationStatGroupByUser()"
                                    v-model="by_user.filters.date.from"
                                >
                                </b-datepicker>
                                <b-datepicker
                                    placeholder="Дата регистрации: до"
                                    expanded
                                    @input="getNotificationStatGroupByUser()"
                                    v-model="by_user.filters.date.to"
                                >
                                </b-datepicker>
                                <b-button @click="clear_filer_by_user()">Очистить</b-button>
                            </b-field>
                        </div>
                        <div class="column is-2">
                            <h1 class="title is-4">Всего выбрано {{ by_user.total }}</h1>
                        </div>
                    </div>
                    <b-table
                        :data="by_user.data"
                        :loading="loading"
                        paginated
                        backend-pagination
                        :total="by_user.total"
                        :per-page="by_user.perPage"
                        @page-change="onPageChangeByUser"
                        aria-next-label="Next page"
                        aria-previous-label="Previous page"
                        aria-page-label="Page"
                        aria-current-label="Current page"
                        backend-sorting
                        :default-sort="[by_user.sortField, by_user.sortOrder]"
                        @sort="onSortByUser"
                    >
                        <template slot-scope="props">
                            <b-table-column field="profile_id" label="ID пользователя" sortable>
                                {{ props.row.profile_id }}
                            </b-table-column>

                            <b-table-column field="phone" label="Номер" sortable>
                                {{ props.row.phone }}
                            </b-table-column>

                            <b-table-column field="calls" label="Звонки" sortable>
                                {{ props.row.calls }}
                            </b-table-column>

                            <b-table-column field="answered_calls" label="Успешные звонки" sortable>
                                {{ props.row.answered_calls }}
                            </b-table-column>

                            <b-table-column field="smses" label="Смс" sortable>
                                {{ props.row.smses }}
                            </b-table-column>

                            <b-table-column field="clicked_links" label="Клики" sortable>
                                {{ props.row.clicked_links }}
                            </b-table-column>

                            <b-table-column field="cost" label="Стоимость" sortable>
                                {{ props.row.cost }}
                            </b-table-column>
                        </template>
                      <template slot="bottom-left">
                        <div class="pagination-controls">
                          <b-select v-model="by_user.perPage" @change.native="getNotificationStatGroupByUser()" class="is-inline-block">
                              <option value="10">10 на странице</option>
                              <option value="20">20 на странице</option>
                              <option value="50">50 на странице</option>
                              <option value="100">100 на странице</option>
                          </b-select>
                        </div>
                      </template>
                    </b-table>
                </section>
            </b-tab-item>

            <b-tab-item label="По рассылкам">
                <section>
                    <v-row style="margin-bottom:5px">
                        <v-col>
                           <h1 class="title is-4">Всего рассылок: {{ by_delivery.total }}</h1>
                            <h1 class="title is-4">Всего потрачено на рассылки: {{ by_delivery.total_sum }}</h1>
                            <h1 class="title is-4">Среднее время отправки: {{ by_delivery.average_time }}</h1>
                        </v-col>
                    </v-row>
                    <v-expansion-panels multiple>
                        <v-expansion-panel>
                            <v-expansion-panel-header class="table-filters-header"
                            >Фильтры</v-expansion-panel-header
                            >
                            <v-expansion-panel-content>
                                <v-col>
                                    <v-row>
                                        <v-col>
                                          <v-text-field
                                            v-model="by_delivery.filters.id.value"
                                            clearable
                                            label="Id"
                                            type="text"
                                            outlined dense hide-details
                                            @click:clear="by_delivery.filters.id.typeOfSearch=''"
                                          >
                                            <template v-slot:append>
                                              <b-dropdown style="margin-bottom:3px;" v-model="by_delivery.filters.id.typeOfSearch" aria-role="list">
                                                    <template #trigger>
                                                        <b-icon class="media-left" icon="help-circle" size="is-medium"></b-icon>
                                                    </template>
                                                    <div v-for="item in typeOfSearch">
                                                        <b-dropdown-item :value="item.value" aria-role="listitem">
                                                            <div class="media">
                                                                <b-icon class="media-left" icon="earth"></b-icon>
                                                                <div class="media-content">
                                                                    <h3>{{ item.name }}</h3>
                                                                </div>
                                                            </div>
                                                        </b-dropdown-item>
                                                    </div>
                                              </b-dropdown>
                                            </template>
                                          </v-text-field>
                                        </v-col>
                                        <v-col>
                                            <TimePicker
                                                :model.sync="by_delivery.filters.date.from.value"
                                                label="Дата отправки: от"
                                                :outlined="true"
                                                :dense="true"
                                            ></TimePicker>
                                        </v-col>
                                        <v-col>
                                            <TimePicker
                                                :model.sync="by_delivery.filters.date.to.value"
                                                label="Дата отправки: до"
                                                :outlined="true"
                                                :dense="true"
                                            ></TimePicker>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>
                                          <v-text-field
                                            v-model="by_delivery.filters.aff_sub1.value"
                                            clearable
                                            label="Aff_sub1"
                                            type="text"
                                            outlined dense hide-details
                                            @click:clear="by_delivery.filters.aff_sub1.typeOfSearch=''"
                                          >
                                            <template v-slot:append>
                                              <b-dropdown style="margin-bottom:3px;" v-model="by_delivery.filters.aff_sub1.typeOfSearch" aria-role="list">
                                                    <template #trigger>
                                                        <b-icon class="media-left" icon="help-circle" size="is-medium"></b-icon>
                                                    </template>
                                                    <div v-for="item in typeOfSearch">
                                                        <b-dropdown-item :value="item.value" aria-role="listitem">
                                                            <div class="media">
                                                                <b-icon class="media-left" icon="earth"></b-icon>
                                                                <div class="media-content">
                                                                    <h3>{{ item.name }}</h3>
                                                                </div>
                                                            </div>
                                                        </b-dropdown-item>
                                                    </div>
                                              </b-dropdown>
                                            </template>
                                          </v-text-field>
                                        </v-col>
                                        <v-col>
                                          <v-text-field
                                            v-model="by_delivery.filters.aff_sub2.value"
                                            clearable
                                            label="Aff_sub2"
                                            type="text"
                                            outlined dense hide-details
                                            @click:clear="by_delivery.filters.aff_sub2.typeOfSearch=''"
                                          >
                                            <template v-slot:append>
                                              <b-dropdown style="margin-bottom:3px;" v-model="by_delivery.filters.aff_sub2.typeOfSearch" aria-role="list">
                                                    <template #trigger>
                                                        <b-icon class="media-left" icon="help-circle" size="is-medium"></b-icon>
                                                    </template>
                                                    <div v-for="item in typeOfSearch">
                                                        <b-dropdown-item :value="item.value" aria-role="listitem">
                                                            <div class="media">
                                                                <b-icon class="media-left" icon="earth"></b-icon>
                                                                <div class="media-content">
                                                                    <h3>{{ item.name }}</h3>
                                                                </div>
                                                            </div>
                                                        </b-dropdown-item>
                                                    </div>
                                              </b-dropdown>
                                            </template>
                                          </v-text-field>
                                        </v-col>
                                        <v-col>
                                          <v-text-field
                                            v-model="by_delivery.filters.aff_sub3.value"
                                            clearable
                                            label="Aff_sub3"
                                            type="text"
                                            outlined dense hide-details
                                            @click:clear="by_delivery.filters.aff_sub3.typeOfSearch=''"
                                          >
                                            <template v-slot:append>
                                              <b-dropdown style="margin-bottom:3px;" v-model="by_delivery.filters.aff_sub3.typeOfSearch" aria-role="list">
                                                    <template #trigger>
                                                        <b-icon class="media-left" icon="help-circle" size="is-medium"></b-icon>
                                                    </template>
                                                    <div v-for="item in typeOfSearch">
                                                        <b-dropdown-item :value="item.value" aria-role="listitem">
                                                            <div class="media">
                                                                <b-icon class="media-left" icon="earth"></b-icon>
                                                                <div class="media-content">
                                                                    <h3>{{ item.name }}</h3>
                                                                </div>
                                                            </div>
                                                        </b-dropdown-item>
                                                    </div>
                                              </b-dropdown>
                                            </template>
                                          </v-text-field>
                                        </v-col>
                                        <v-col>
                                          <v-text-field
                                            v-model="by_delivery.filters.aff_sub4.value"
                                            clearable
                                            label="Aff_sub4"
                                            type="text"
                                            outlined dense hide-details
                                            @click:clear="by_delivery.filters.aff_sub4.typeOfSearch=''"
                                          >
                                            <template v-slot:append>
                                              <b-dropdown style="margin-bottom:3px;" v-model="by_delivery.filters.aff_sub4.typeOfSearch" aria-role="list">
                                                    <template #trigger>
                                                        <b-icon class="media-left" icon="help-circle" size="is-medium"></b-icon>
                                                    </template>
                                                    <div v-for="item in typeOfSearch">
                                                        <b-dropdown-item :value="item.value" aria-role="listitem">
                                                            <div class="media">
                                                                <b-icon class="media-left" icon="earth"></b-icon>
                                                                <div class="media-content">
                                                                    <h3>{{ item.name }}</h3>
                                                                </div>
                                                            </div>
                                                        </b-dropdown-item>
                                                    </div>
                                              </b-dropdown>
                                            </template>
                                          </v-text-field>
                                        </v-col>
                                        <v-col>
                                          <v-text-field
                                            v-model="by_delivery.filters.aff_sub5.value"
                                            clearable
                                            label="Aff_sub5"
                                            type="text"
                                            outlined dense hide-details
                                            @click:clear="by_delivery.filters.aff_sub5.typeOfSearch=''"
                                          >
                                            <template v-slot:append>
                                              <b-dropdown style="margin-bottom:3px;" v-model="by_delivery.filters.aff_sub5.typeOfSearch" aria-role="list">
                                                    <template #trigger>
                                                        <b-icon class="media-left" icon="help-circle" size="is-medium"></b-icon>
                                                    </template>
                                                    <div v-for="item in typeOfSearch">
                                                        <b-dropdown-item :value="item.value" aria-role="listitem">
                                                            <div class="media">
                                                                <b-icon class="media-left" icon="earth"></b-icon>
                                                                <div class="media-content">
                                                                    <h3>{{ item.name }}</h3>
                                                                </div>
                                                            </div>
                                                        </b-dropdown-item>
                                                    </div>
                                              </b-dropdown>
                                            </template>
                                          </v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                    <v-row>
                        <v-col>
                            <div class="float-right">
                                <v-btn @click="clear_filer_by_delivery()" color="info" style="margin: 10px;">Очистить</v-btn>
                                <v-btn @click="load('deliveries')" color="primary" style="margin: 10px;">
                                    Загрузить
                                </v-btn>
                            </div>
                        </v-col>
                    </v-row>
                    <b-table
                        :data="by_delivery.data"
                        :loading="loading"
                        paginated
                        backend-pagination
                        :total="by_delivery.total"
                        :per-page="by_delivery.perPage"
                        @page-change="onPageChangeDelivery"
                        aria-next-label="Next page"
                        aria-previous-label="Previous page"
                        aria-page-label="Page"
                        aria-current-label="Current page"
                        backend-sorting
                        :default-sort="[by_delivery.sortField, by_delivery.sortOrder]"
                        @sort="onSortByDelivery"
                        :opened-detailed="defaultOpenedDetails3"
                        detailed
                        detail-key="delivery_id"
                    >
                        <template slot-scope="props">
                            <b-table-column field="delivery_id" label="ID рассылки" sortable>
                                {{ props.row.delivery_id }}
                            </b-table-column>

                            <b-table-column
                                field="planned_at"
                                label="Запланированная дата отправки"
                                sortable
                            >
                                {{ props.row.planned_at | isoToDateTime }}
                            </b-table-column>

                            <b-table-column field="total_time_in_seconds" label="Время отправки рассылки" sortable>
                                {{ props.row.total_time }}
                            </b-table-column>

                            <b-table-column field="template_name" label="Шаблон рассылки">
                                {{ props.row.template_name }}
                            </b-table-column>

                            <b-table-column field="source" label="Source">
                                {{ props.row.source }}
                            </b-table-column>

                            <b-table-column field="type" label="Тип">
                                {{ props.row.type }}
                            </b-table-column>

                            <b-table-column field="smses" label="Смс (sent/delivered/not_delivered/error)">
                                {{ props.row.smses }}
                            </b-table-column>

                            <b-table-column field="clicked_links" label="Клики">
                                {{ props.row.clicked_links }}
                            </b-table-column>

                            <b-table-column field="calls" label="Звонки (all/finished)">
                                {{ props.row.calls }}
                            </b-table-column>

                            <b-table-column field="cost" label="Стоимость" sortable>
                                {{ props.row.cost }}
                            </b-table-column>
                        </template>
                        <template slot="detail" slot-scope="props">
                            <b-table
                                :data="props.row.templates_data"
                            >
                                <template slot-scope="props2">
                                    <b-table-column field="template_info_name" label="Этап">
                                        {{ props2.row.template_info_name }}
                                    </b-table-column>

                                    <b-table-column field="smses" label="Смс (sent/delivered/not_delivered/error)">
                                        {{ props2.row.smses }}
                                    </b-table-column>

                                    <b-table-column field="clicked_links" label="Клики">
                                        {{ props2.row.clicked_links }}
                                    </b-table-column>

                                    <b-table-column field="calls" label="Звонки (all/finished)">
                                        {{ props2.row.calls }}
                                    </b-table-column>

                                    <b-table-column field="cost" label="Стоимость" sortable>
                                        {{ props2.row.cost }}
                                    </b-table-column>
                                </template>
                            </b-table>
                        </template>
                        <template slot="bottom-left">
                            <div class="pagination-controls">
                              <b-select v-model="by_delivery.perPage" @change.native="getNotificationStatGroupByDelivery()" class="is-inline-block">
                                  <option value="10">10 на странице</option>
                                  <option value="20">20 на странице</option>
                                  <option value="50">50 на странице</option>
                                  <option value="100">100 на странице</option>
                              </b-select>
                            </div>
                        </template>
                    </b-table>
                </section>
            </b-tab-item>

            <b-tab-item label="По цепочкам">
                <section>
                    <v-expansion-panels multiple>
                        <v-expansion-panel>
                            <v-expansion-panel-header class="table-filters-header"
                            >Фильтры</v-expansion-panel-header
                            >
                            <v-expansion-panel-content>
                                <v-col>
                                    <v-row>
                                        <v-col>
                                          <v-text-field
                                            v-model="by_chains.filters.id.value"
                                            clearable
                                            label="Id"
                                            type="text"
                                            outlined dense hide-details
                                            @click:clear="by_chains.filters.id.typeOfSearch=''"
                                          >
                                            <template v-slot:append>
                                              <b-dropdown style="margin-bottom:3px;" v-model="by_chains.filters.id.typeOfSearch" aria-role="list">
                                                    <template #trigger>
                                                        <b-icon class="media-left" icon="help-circle" size="is-medium"></b-icon>
                                                    </template>
                                                    <div v-for="item in typeOfSearch">
                                                        <b-dropdown-item :value="item.value" aria-role="listitem">
                                                            <div class="media">
                                                                <b-icon class="media-left" icon="earth"></b-icon>
                                                                <div class="media-content">
                                                                    <h3>{{ item.name }}</h3>
                                                                </div>
                                                            </div>
                                                        </b-dropdown-item>
                                                    </div>
                                              </b-dropdown>
                                            </template>
                                          </v-text-field>
                                        </v-col>
                                        <v-col>
                                            <TimePicker
                                                :model.sync="by_chains.filters.date.from.value"
                                                label="Дата отправки: от"
                                                :outlined="true"
                                                :dense="true"
                                            ></TimePicker>
                                        </v-col>
                                        <v-col>
                                            <TimePicker
                                                :model.sync="by_chains.filters.date.to.value"
                                                label="Дата отправки: до"
                                                :outlined="true"
                                                :dense="true"
                                            ></TimePicker>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>
                                          <v-text-field
                                            v-model="by_chains.filters.aff_sub1.value"
                                            clearable
                                            label="Aff_sub1"
                                            type="text"
                                            outlined dense hide-details
                                            @click:clear="by_chains.filters.aff_sub1.typeOfSearch=''"
                                          >
                                            <template v-slot:append>
                                              <b-dropdown style="margin-bottom:3px;" v-model="by_chains.filters.aff_sub1.typeOfSearch" aria-role="list">
                                                    <template #trigger>
                                                        <b-icon class="media-left" icon="help-circle" size="is-medium"></b-icon>
                                                    </template>
                                                    <div v-for="item in typeOfSearch">
                                                        <b-dropdown-item :value="item.value" aria-role="listitem">
                                                            <div class="media">
                                                                <b-icon class="media-left" icon="earth"></b-icon>
                                                                <div class="media-content">
                                                                    <h3>{{ item.name }}</h3>
                                                                </div>
                                                            </div>
                                                        </b-dropdown-item>
                                                    </div>
                                              </b-dropdown>
                                            </template>
                                          </v-text-field>
                                        </v-col>
                                        <v-col>
                                          <v-text-field
                                            v-model="by_chains.filters.aff_sub2.value"
                                            clearable
                                            label="Aff_sub2"
                                            type="text"
                                            outlined dense hide-details
                                            @click:clear="by_chains.filters.aff_sub2.typeOfSearch=''"
                                          >
                                            <template v-slot:append>
                                              <b-dropdown style="margin-bottom:3px;" v-model="by_chains.filters.aff_sub2.typeOfSearch" aria-role="list">
                                                    <template #trigger>
                                                        <b-icon class="media-left" icon="help-circle" size="is-medium"></b-icon>
                                                    </template>
                                                    <div v-for="item in typeOfSearch">
                                                        <b-dropdown-item :value="item.value" aria-role="listitem">
                                                            <div class="media">
                                                                <b-icon class="media-left" icon="earth"></b-icon>
                                                                <div class="media-content">
                                                                    <h3>{{ item.name }}</h3>
                                                                </div>
                                                            </div>
                                                        </b-dropdown-item>
                                                    </div>
                                              </b-dropdown>
                                            </template>
                                          </v-text-field>
                                        </v-col>
                                        <v-col>
                                          <v-text-field
                                            v-model="by_chains.filters.aff_sub3.value"
                                            clearable
                                            label="Aff_sub3"
                                            type="text"
                                            outlined dense hide-details
                                            @click:clear="by_chains.filters.aff_sub3.typeOfSearch=''"
                                          >
                                            <template v-slot:append>
                                              <b-dropdown style="margin-bottom:3px;" v-model="by_chains.filters.aff_sub3.typeOfSearch" aria-role="list">
                                                    <template #trigger>
                                                        <b-icon class="media-left" icon="help-circle" size="is-medium"></b-icon>
                                                    </template>
                                                    <div v-for="item in typeOfSearch">
                                                        <b-dropdown-item :value="item.value" aria-role="listitem">
                                                            <div class="media">
                                                                <b-icon class="media-left" icon="earth"></b-icon>
                                                                <div class="media-content">
                                                                    <h3>{{ item.name }}</h3>
                                                                </div>
                                                            </div>
                                                        </b-dropdown-item>
                                                    </div>
                                              </b-dropdown>
                                            </template>
                                          </v-text-field>
                                        </v-col>
                                        <v-col>
                                          <v-text-field
                                            v-model="by_chains.filters.aff_sub4.value"
                                            clearable
                                            label="Aff_sub4"
                                            type="text"
                                            outlined dense hide-details
                                            @click:clear="by_chains.filters.aff_sub4.typeOfSearch=''"
                                          >
                                            <template v-slot:append>
                                              <b-dropdown style="margin-bottom:3px;" v-model="by_chains.filters.aff_sub4.typeOfSearch" aria-role="list">
                                                    <template #trigger>
                                                        <b-icon class="media-left" icon="help-circle" size="is-medium"></b-icon>
                                                    </template>
                                                    <div v-for="item in typeOfSearch">
                                                        <b-dropdown-item :value="item.value" aria-role="listitem">
                                                            <div class="media">
                                                                <b-icon class="media-left" icon="earth"></b-icon>
                                                                <div class="media-content">
                                                                    <h3>{{ item.name }}</h3>
                                                                </div>
                                                            </div>
                                                        </b-dropdown-item>
                                                    </div>
                                              </b-dropdown>
                                            </template>
                                          </v-text-field>
                                        </v-col>
                                        <v-col>
                                          <v-text-field
                                            v-model="by_chains.filters.aff_sub5.value"
                                            clearable
                                            label="Aff_sub5"
                                            type="text"
                                            outlined dense hide-details
                                            @click:clear="by_chains.filters.aff_sub5.typeOfSearch=''"
                                          >
                                            <template v-slot:append>
                                              <b-dropdown style="margin-bottom:3px;" v-model="by_chains.filters.aff_sub5.typeOfSearch" aria-role="list">
                                                    <template #trigger>
                                                        <b-icon class="media-left" icon="help-circle" size="is-medium"></b-icon>
                                                    </template>
                                                    <div v-for="item in typeOfSearch">
                                                        <b-dropdown-item :value="item.value" aria-role="listitem">
                                                            <div class="media">
                                                                <b-icon class="media-left" icon="earth"></b-icon>
                                                                <div class="media-content">
                                                                    <h3>{{ item.name }}</h3>
                                                                </div>
                                                            </div>
                                                        </b-dropdown-item>
                                                    </div>
                                              </b-dropdown>
                                            </template>
                                          </v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                    <v-row>
                        <v-col>
                            <div class="float-right">
                                <v-btn @click="clear_filer_by_chains()" color="info" style="margin: 10px;">Очистить</v-btn>
                                <v-btn @click="load('chains')" color="primary" style="margin: 10px;">
                                    Загрузить
                                </v-btn>
                            </div>
                        </v-col>
                    </v-row>

                    <b-table
                        :data="by_chains.data"
                        :loading="loading"
                        paginated
                        backend-pagination
                        :total="by_chains.total"
                        :per-page="by_chains.perPage"
                        @page-change="onPageChangeChain"
                        aria-next-label="Next page"
                        aria-previous-label="Previous page"
                        aria-page-label="Page"
                        aria-current-label="Current page"
                        backend-sorting
                        :default-sort="[by_chains.sortField, by_chains.sortOrder]"
                        @sort="onSortByChains"
                        :opened-detailed="defaultOpenedDetails"
                        detailed
                        detail-key="chain_name"
                    >
                        <template slot-scope="props">
                            <b-table-column field="type" label="Тип уведомления" sortable>
                                {{ props.row.type }}
                            </b-table-column>

                            <b-table-column field="chain_name" label="Название цепочки" sortable>
                                {{ props.row.chain_name }}
                            </b-table-column>

                            <b-table-column field="count_all" label="Количество" sortable>
                                {{ props.row.count_all }}
                            </b-table-column>

                            <b-table-column field="success_count" label="Количество успешных" sortable>
                                {{ props.row.success_count }}
                            </b-table-column>

                            <b-table-column ctr="count_all" label="CTR(в %)" sortable>
                                {{ props.row.ctr }}
                            </b-table-column>

                            <b-table-column field="cost" label="Стоимость" sortable>
                                {{ props.row.cost }}
                            </b-table-column>

                            <b-table-column field="notif_price" label="Средняя стоимость смс" sortable>
                                {{ props.row.notif_price }}
                            </b-table-column>

                            <b-table-column field="success_notif_price" label="Средняя стоимость смс с кликом" sortable>
                                {{ props.row.success_notif_price }}
                            </b-table-column>
                        </template>
                        <template slot="detail" slot-scope="props">
                            <b-table
                                :data="props.row.templates_data"
                                :opened-detailed="defaultOpenedDetails2"
                                detailed
                                detail-key="notification_name"
                            >
                                <template slot-scope="props2">
                                    <b-table-column field="notification_name" label="Название шаблона" sortable>
                                        {{ props2.row.notification_name }}
                                    </b-table-column>

                                    <b-table-column field="count_all" label="Количество" sortable>
                                        {{ props2.row.count_all }}
                                    </b-table-column>

                                    <b-table-column field="success_count" label="Количество успешных" sortable>
                                        {{ props2.row.success_count }}
                                    </b-table-column>

                                    <b-table-column ctr="count_all" label="CTR(в %)" sortable>
                                        {{ props2.row.ctr }}
                                    </b-table-column>

                                    <b-table-column field="cost" label="Стоимость" sortable>
                                        {{ props2.row.cost }}
                                    </b-table-column>

                                    <b-table-column field="notif_price" label="Средняя стоимость смс" sortable>
                                        {{ props2.row.notif_price }}
                                    </b-table-column>

                                    <b-table-column field="success_notif_price" label="Средняя стоимость смс с кликом" sortable>
                                        {{ props2.row.success_notif_price }}
                                    </b-table-column>
                                </template>
                                <template slot="detail" slot-scope="props2">
                            <b-table
                                :data="props2.row.templates_data"
                            >
                                <template slot-scope="props3">
                                    <b-table-column field="template_name" label="Этап" sortable>
                                        {{ props3.row.template_name }}
                                    </b-table-column>

                                    <b-table-column field="count_all" label="Количество" sortable>
                                        {{ props3.row.count_all }}
                                    </b-table-column>

                                    <b-table-column field="success_count" label="Количество успешных" sortable>
                                        {{ props3.row.success_count }}
                                    </b-table-column>

                                    <b-table-column ctr="count_all" label="CTR(в %)" sortable>
                                        {{ props3.row.ctr }}
                                    </b-table-column>

                                    <b-table-column field="cost" label="Стоимость" sortable>
                                        {{ props3.row.cost }}
                                    </b-table-column>

                                    <b-table-column field="notif_price" label="Средняя стоимость смс" sortable>
                                        {{ props3.row.notif_price }}
                                    </b-table-column>

                                    <b-table-column field="success_notif_price" label="Средняя стоимость смс с кликом" sortable>
                                        {{ props3.row.success_notif_price }}
                                    </b-table-column>
                                </template>
                            </b-table>
                </template>
                            </b-table>
                        </template>
                        <template slot="bottom-left">
                        <div class="pagination-controls">
                          <b-select v-model="by_chains.perPage" @change.native="getNotificationStatGroupByChains()" class="is-inline-block">
                              <option value="10">10 на странице</option>
                              <option value="20">20 на странице</option>
                              <option value="50">50 на странице</option>
                              <option value="100">100 на странице</option>
                          </b-select>
                        </div>
                        </template>
                    </b-table>
                </section>
            </b-tab-item>
        </b-tabs>
    </div>
</template>

<script>
import TimePicker from "@/app/shared/components/form-inputs/TimePicker";

export default {
    name: "NotificationStatistics",
    components: {TimePicker},
    data() {
        return {
            defaultOpenedDetails: [1],
            defaultOpenedDetails2: [1],
            defaultOpenedDetails3: [1],
            selectedTab: 0,
            selectedType: 0,
            selectedChain: 0,
            selectedUrl: '',
            selectedNotifType: '',
            aff_subs: {},
            all: {
                data: [],
                total: 0,
                sortField: "created_at",
                sortOrder: "desc",
                page: 1,
                perPage: 20,
                filters: {
                    profile_id: "",
                    date: {},
                },
            },
            by_user: {
                data: [],
                total: 0,
                sortField: "profile_id",
                sortOrder: "desc",
                page: 1,
                perPage: 20,
                filters: {
                    profile_id: "",
                    date: {},
                },
            },
            by_delivery: {
                data: [],
                total: 0,
                total_sum: 0,
                sortField: "delivery_id",
                sortOrder: "desc",
                page: 1,
                perPage: 20,
                average_time: "0 сек./ 0.0 мин./ 0.0 ч.",
                filters: {
                    date: { to: {value: "", is_used: false}, from: {value: "", is_used: false} },
                    id: {value: "", is_used: false, typeOfSearch: ''},
                    aff_sub1: {value: "", is_used: false, typeOfSearch: ''},
                    aff_sub2: {value: "", is_used: false, typeOfSearch: ''},
                    aff_sub3: {value: "", is_used: false, typeOfSearch: ''},
                    aff_sub4: {value: "", is_used: false, typeOfSearch: ''},
                    aff_sub5: {value: "", is_used: false, typeOfSearch: ''},
                },
            },
            by_chains: {
                data: [],
                total: 0,
                sortField: "chain_name",
                sortOrder: "asc",
                page: 1,
                perPage: 20,
                filters: {
                    date: { to: {value: "", is_used: false}, from: {value: "", is_used: false} },
                    id: {value: "", is_used: false, typeOfSearch: ''},
                    aff_sub1: {value: "", is_used: false, typeOfSearch: ''},
                    aff_sub2: {value: "", is_used: false, typeOfSearch: ''},
                    aff_sub3: {value: "", is_used: false, typeOfSearch: ''},
                    aff_sub4: {value: "", is_used: false, typeOfSearch: ''},
                    aff_sub5: {value: "", is_used: false, typeOfSearch: ''},
                },
                selector: "",
                ifEmpty: false,
            },
            sum: {
                data: {},
            },
            loading: false,
            typeOfSearch: [
                { name: "Содержит", value: 'contains' },
                { name: "Не содержит", value: 'not contains' },
                { name: "Пустое?", value: 'empty' },
                { name: "Совпадает", value: 'equal' },
                { name: "Не требуется", value: '' },
            ],
        };
    },
    created: function () {
        this.getNotificationStatSum();
    },
    methods: {
        ifEmptyChains() {
            let count = 0;
            this.by_chains.data.map(function(e) { if ((Object.values(e)[0]).length === 0) {
                count += 1;
            }});
            if (count === 3) return true;
            return false;
        },
        filter_names(names, param) {
            const filteredNames = [];
            names.forEach((element) => { if (!filteredNames.includes(element[param])) { filteredNames.push(element[param]); } });
            return filteredNames;
        },
        filter_items(items, affSubs, tab) {
            let result = items;
            for (var key in affSubs) {
                if (affSubs[key] !== 'all' && this.by_chains.filters[key].is_used) {
                    result = result.filter(function(obj) {
                        return obj[key] === affSubs[key];
                    });
                }
            }
            tab.total = result.reduce((accumulator, object) => {
              return accumulator + object['cost'];
            }, 0);
            return result;
        },
        updateUrl() {
            this.selectedUrl = '';
        },
        load(type) {
            switch (type) {
                case "all":
                    this.getNotificationStatAll();
                    break;
                case "users":
                    this.getNotificationStatGroupByUser();
                    break;
                case "deliveries":
                    this.getNotificationStatGroupByDelivery();
                    break;
                case "chains":
                    this.getNotificationStatGroupByChains();
                    break;
            }
        },
        getNotificationStatGroupByUser() {
            this.loading = true;
            let params = {
                sort_by: this.by_user.sortField,
                order: this.by_user.sortOrder,
                page: this.by_user.page,
                perPage: this.by_user.perPage,
                filters: JSON.parse(JSON.stringify(this.by_user.filters))
            };

            params.filters.date.from = new Date(params.filters.date.from);
            params.filters.date.to = new Date(params.filters.date.to);

            this.$store
                .dispatch("GET_NOTIFICATION_STAT_GROUP_BY_USER", params)
                .then((data) => {
                    this.by_user.data = data.data.results;
                    this.by_user.total = data.data.total;
                    this.by_user.page = data.data.page;
                })
                .catch((error) => {
                    this.$toaster.error("Неизвестная ошибка!");
                    this.by_user.data = [];
                    this.by_user.total = 0;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getNotificationStatAll() {
            this.loading = true;
            let params = {
                sort_by: this.all.sortField,
                order: this.all.sortOrder,
                page: this.all.page,
                perPage: this.all.perPage,
                filters: this.all.filters,
            };
            this.$store
                .dispatch("GET_NOTIFICATION_STAT_ALL", params)
                .then((data) => {
                    this.all.data = data.data.results;
                    this.all.total = data.data.total;
                    this.all.page = data.data.page;
                })
                .catch((error) => {
                    this.$toaster.error("Неизвестная ошибка!");
                    this.all.data = [];
                    this.all.total = 0;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getNotificationStatGroupByDelivery() {
            this.loading = true;
            let params = {
                sort_by: this.by_delivery.sortField,
                order: this.by_delivery.sortOrder,
                page: this.by_delivery.page,
                perPage: this.by_delivery.perPage,
                filters: JSON.parse(JSON.stringify(this.by_delivery.filters))
            };

            let diff = new Date().getTimezoneOffset();

            if (params.filters.date.from.value) {
                let some_date = new Date(params.filters.date.from.value);
                some_date.setMinutes(some_date.getMinutes() + diff);
                params.filters.date.from.value = some_date;
            }
            if (params.filters.date.to.value) {
                let some_date = new Date(params.filters.date.to.value);
                some_date.setMinutes(some_date.getMinutes() + diff);
                params.filters.date.to.value = some_date;
            }

            this.$store
                .dispatch("GET_NOTIFICATION_STAT_GROUP_BY_DELIVERY", params)
                .then((data) => {
                    this.by_delivery.data = data.data.results;
                    this.by_delivery.total = data.data.total;
                    this.by_delivery.page = data.data.page;
                    this.by_delivery.total_sum = data.data.total_sum;
                    this.by_delivery.average_time = data.data.average_time;
                })
                .catch((error) => {
                    this.$toaster.error("Неизвестная ошибка!");
                    this.by_delivery.data = [];
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getNotificationStatSum() {
            this.loading = true;
            let params = {};
            this.$store
                .dispatch("GET_NOTIFICATION_STAT_SUM", params)
                .then((data) => {
                    this.sum.data = data.data;
                })
                .catch((error) => {
                    this.$toaster.error("Неизвестная ошибка!");
                    this.sum.data = [];
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getNotificationStatGroupByChains() {
            this.loading = true;
            let params = {
                sort_by: this.by_chains.sortField,
                order: this.by_chains.sortOrder,
                page: this.by_chains.page,
                perPage: this.by_chains.perPage,
                filters: JSON.parse(JSON.stringify(this.by_chains.filters)),
            };

            let diff = new Date().getTimezoneOffset();

            if (params.filters.date.from.value) {
                let some_date = new Date(params.filters.date.from.value);
                some_date.setMinutes(some_date.getMinutes() + diff);
                params.filters.date.from.value = some_date;
            }
            if (params.filters.date.to.value) {
                let some_date = new Date(params.filters.date.to.value);
                some_date.setMinutes(some_date.getMinutes() + diff);
                params.filters.date.to.value = some_date;
            }

            this.$store
                .dispatch("GET_NOTIFICATION_STAT_GROUP_BY_CHAINS", params)
                .then((data) => {
                    this.by_chains.data = data.data.results;
                    this.by_chains.ifEmpty = this.ifEmptyChains();
                })
                .catch((error) => {
                    this.$toaster.error("Неизвестная ошибка!");
                    this.by_chains.data = [];
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        /*
         * Handle page-change event
         */
        onPageChangeByUser(page) {
            this.by_user.page = page;
            this.getNotificationStatGroupByUser();
        },
        onPageChangeAll(page) {
            this.all.page = page;
            this.getNotificationStatAll();
        },
        onPageChangeDelivery(page) {
            this.by_delivery.page = page;
            this.getNotificationStatGroupByDelivery();
        },
        onPageChangeChain(page) {
            this.by_chains.page = page;
            this.getNotificationStatGroupByChains();
        },
        /*
         * Handle sort event
         */
        onSortByUser(field, order) {
            this.by_user.sortField = field;
            this.by_user.sortOrder = order;
            this.getNotificationStatGroupByUser();
        },
        onSortAll(field, order) {
            this.all.sortField = field;
            this.all.sortOrder = order;
            this.getNotificationStatAll();
        },
        onSortByDelivery(field, order) {
            this.by_delivery.sortField = field;
            this.by_delivery.sortOrder = order;
            this.getNotificationStatGroupByDelivery();
        },
        onSortByChains(field, order) {
            this.by_chains.sortField = field;
            this.by_chains.sortOrder = order;
            this.getNotificationStatGroupByChains();
        },
        clear_filer_by_user() {
            this.by_user.filters.date = {};
            this.by_user.filters.profile_id = "";
            this.getNotificationStatGroupByUser();
        },
        clear_filer_all() {
            this.all.filters.date = { };
            this.all.filters.profile_id = "";
            this.getNotificationStatAll();
        },
        clear_filer_by_chains() {
            this.by_chains.filters.date = { to: {value: "", is_used: false}, from: {value: "", is_used: false} };
            this.by_chains.filters.id = {value: "", is_used: false, typeOfSearch: ''};
            this.by_chains.filters.aff_sub1 = {value: "", is_used: false, typeOfSearch: ''};
            this.by_chains.filters.aff_sub2 = {value: "", is_used: false, typeOfSearch: ''};
            this.by_chains.filters.aff_sub3 = {value: "", is_used: false, typeOfSearch: ''};
            this.by_chains.filters.aff_sub4 = {value: "", is_used: false, typeOfSearch: ''};
            this.by_chains.filters.aff_sub5 = {value: "", is_used: false, typeOfSearch: ''};
            this.getNotificationStatGroupByChains();
        },
        clear_filer_by_delivery() {
            this.by_delivery.filters.date = { to: {value: "", is_used: false}, from: {value: "", is_used: false} };
            this.by_delivery.filters.id = {value: "", is_used: false, typeOfSearch: ''};
            this.by_delivery.filters.aff_sub1 = {value: "", is_used: false, typeOfSearch: ''};
            this.by_delivery.filters.aff_sub2 = {value: "", is_used: false, typeOfSearch: ''};
            this.by_delivery.filters.aff_sub3 = {value: "", is_used: false, typeOfSearch: ''};
            this.by_delivery.filters.aff_sub4 = {value: "", is_used: false, typeOfSearch: ''};
            this.by_delivery.filters.aff_sub5 = {value: "", is_used: false, typeOfSearch: ''};
            this.getNotificationStatGroupByDelivery();
        },
        type(status) {
            if (status == "sent") {
                return "sent";
            } else if ((status == "delivered") || (status == "finished")) {
                return "delivered";
            } else if ((status == "error") || (status == "canceled") || (status == "failed")) {
                return "error";
            }  else return "st_status";
        },
    },
};
</script>

<style>
.tabs.is-toggle li.is-active a {
    background-color: #1d8f68;
}
.delivered {
    color: #1d8f68;
}
.sent {
    color: #afb326;
}
.error {
    color: #e20000;
}
.st_status {
    color: #000000;
}
</style>
